import {
  pushSupported,
  pushPermission,
  pushSubscribed,
  pushBusy,
  pushError,
  enablePush,
  disablePush,
} from '@/pwa/push';
import { isIOS, isStandalone } from '@/pwa/install';
import { notify } from '@/store/ui';
import css from './PushToggle.module.css';

/**
 * Переключатель push-уведомлений (в Dashboard / профиле).
 * Учитывает ограничения iOS: push доступен только в установленном PWA (iOS 16.4+).
 */
export function PushToggle() {
  if (!pushSupported.value) {
    // На iOS Safari (не установленном) PushManager отсутствует — подсказываем установку.
    if (isIOS.value && !isStandalone.value) {
      return (
        <section class="panel">
          <h3 class="panel-title">Уведомления</h3>
          <p class={css.hint}>
            Чтобы получать уведомления о заказах на iPhone, установите приложение на экран «Домой»
            (кнопка «Установить приложение» в меню), затем откройте его и включите уведомления.
          </p>
        </section>
      );
    }
    return null;
  }

  const subscribed = pushSubscribed.value;
  const denied = pushPermission.value === 'denied';
  const busy = pushBusy.value;

  async function toggle() {
    if (busy) return;
    if (subscribed) {
      const ok = await disablePush();
      if (ok) notify('Уведомления отключены');
    } else {
      const ok = await enablePush();
      if (ok) notify('Уведомления включены');
    }
  }

  return (
    <section class="panel">
      <h3 class="panel-title">Push-уведомления</h3>
      <div class={css.row}>
        <div class={css.text}>
          <div class={css.title}>Уведомления о заказах</div>
          <div class={css.subtitle}>
            Статусы заказа, готовность счёта и УПД, коды маркировки — прямо на устройство.
          </div>
        </div>
        <label class={css.switch} aria-label="Push-уведомления">
          <input type="checkbox" checked={subscribed} disabled={busy || denied} onChange={toggle} />
          <span class={css.slider} />
        </label>
      </div>

      {denied && (
        <p class={css.denied}>
          Уведомления заблокированы в браузере. Разрешите их в настройках сайта, чтобы включить.
        </p>
      )}
      {pushError.value && !denied && <p class={css.error}>{pushError.value}</p>}
    </section>
  );
}
